import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=6953bf99&scoped=true&lang=pug"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"
import style0 from "./Wallets.vue?vue&type=style&index=0&id=6953bf99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953bf99",
  null
  
)

export default component.exports